<template>
    <v-app-bar
        class="editor-toolbar"
        dark
        color="rgb(47, 47, 47)"
        text
        dense
    >
        <v-autocomplete
            :items="modelList"
            :label="$t('instance.data_model.data_model_toolbar.search_by')"
            persistent-hint
            prepend-icon="mdi-search"
            item-text="name"
            item-value="uid"
            @input="onSelectModel"
        ></v-autocomplete>
        <v-spacer></v-spacer>
        <div style="position: relative; display: inline-block;">
            <!-- Désactivé en attente du potentiel retour de l'édition du datamodel en text -->
            <!-- <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn
                        icon
                        v-on="on"
                        dark
                        :disabled="disableRedrawGraph"
                        @click="savePreviousModel"
                    >
                        <v-icon dark>brush</v-icon>
                    </v-btn>
                </template>
                <span>Redraw graph</span>
            </v-tooltip>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-badge
                        :value="modelNeedsToBeVerified"
                        color="red"
                        overlap
                        class="spellcheck-badge"
                    >
                        <template v-slot:badge>
                            <span>!</span>
                        </template>
                        <v-btn
                            icon
                            v-on="on"
                            :disabled="disableCheckSyntax"
                            dark
                            @click="triggerCorrection"
                        >
                            <v-icon dark>spellcheck</v-icon>
                        </v-btn>
                    </v-badge>
                </template>
                <span>Check syntax</span>
            </v-tooltip> -->
            <div class="btn-create-model">
                <v-btn
                    icon
                    dark
                    :disabled="readOnly"
                    @click="triggerNameModal()"
                    style="font-size: 14px; width: 160px; height:25px; padding-right: 10px; text-transform: initial;"
                >
                    {{$t('instance.data_model.data_model_toolbar.create_model')}}
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <div v-on="on">
                                <v-icon dark style="padding-left: 5px">add_box</v-icon>
                            </div>

                        </template>
                        <span>
                            {{$t('instance.data_model.data_model_toolbar.create_new_model')}}
                        </span>
                    </v-tooltip>
                </v-btn>
            </div>

            <v-card
                v-if="chooseNewName && !readOnly"
                class="choose-model-name"
                transition="scale-transition"
            >
                <v-card-title
                    class="title"
                    v-if="duplicatingModel"
                >
                    {{$t('instance.data_model.data_model_toolbar.duplicate_model')}}
                </v-card-title>
                <v-card-title
                    class="title"
                    v-else
                >
                    {{$t('instance.data_model.data_model_toolbar.create_model')}}
                </v-card-title>
                <v-card-text style="display: flex; align-items: center; padding-top: 0; padding-bottom: 16px;">
                    <v-tooltip
                        bottom
                        :nudge-top="20"
                        :nudge-left="5"
                        v-model="showSuggestion"
                        :style="{'box-shadow': 'none', 'background-color': 'transparent'}"
                    >
                        <template v-slot:activator="{ on }" :tag="'input'">
                            <v-form v-model="formIsValid" ref="form" v-on:submit.prevent>
                                <v-text-field
                                    ref="nameField"
                                    v-model="newModelName"
                                    :rules="formActive?modelNameRules:[]"
                                    :label="$t('instance.data_model.data_model_toolbar.model_name')"
                                    required
                                ></v-text-field>
                            </v-form>
                        </template>
                        <span>
                            {{$t('instance.data_model.name_suggestion.suggestion_text')}}
                            {{invalidNameCase?invalidNameCase.suggestion:''}}
                        </span>
                    </v-tooltip>
                    <div v-if="showSuggestion" class="apply-suggestion-link">
                        <span

                            @click="applySuggestion()"
                        >
                            {{$t('instance.data_model.name_suggestion.apply_text')}}
                        </span>
                    </div>
                    <v-tooltip
                        top
                        v-if="duplicatingModel"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                fab
                                dark
                                small
                                color="grey darken-3"
                                @click="duplicateModel"
                            >
                                <v-icon dark>done</v-icon>
                            </v-btn>
                        </template>
                        <span>
                            {{$t('instance.data_model.data_model_toolbar.duplicate_text')}}
                        </span>
                    </v-tooltip>
                    <v-tooltip
                        top
                        v-else
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                fab
                                dark
                                small
                                color="grey darken-3"
                                @click="createNewModel"
                            >
                                <v-icon dark>done</v-icon>
                            </v-btn>
                        </template>
                        <span>
                            {{$t('instance.data_model.data_model_toolbar.create_text')}}
                        </span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                fab
                                dark
                                small
                                color="grey darken-3"
                                @click="resetCreateNewModel"
                            >
                                <v-icon dark>close</v-icon>
                            </v-btn>
                        </template>
                        <span>
                            {{$t('instance.data_model.data_model_toolbar.close_span')}}
                        </span>
                    </v-tooltip>
                </v-card-text>
                <div
                    v-if="showSuggestion"
                    :style="{'padding': '10px 16px'}"
                >
                    <v-alert
                        color="error"
                        outlined
                    >
                        {{ invalidNameCase.error }}
                        <v-tooltip right>
                            <template v-slot:activator="{ on }">
                                <i v-on="on" aria-hidden="true" class="v-icon material-icons theme--dark" style="font-size: 16px; color: rgb(158, 158, 158); caret-color: rgb(158, 158, 158);">info</i>
                            </template>
                            <span>PascalCase</span>
                        </v-tooltip>
                    </v-alert>
                </div>
            </v-card>
        </div>
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <v-btn
                    icon
                    v-on="on"
                    dark
                    :disabled="readOnly"
                    @click="$eventBus.$emit('import-data-model')"
                >
                    <v-icon>publish</v-icon>
                </v-btn>
            </template>
            <span>
                {{$t('instance.data_model.data_model_toolbar.import')}}
            </span>
        </v-tooltip>
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    icon
                    dark
                    @click="$eventBus.$emit('export-data-model')"
                >
                    <v-icon>get_app</v-icon>
                </v-btn>
            </template>
            <span>
                {{$t('instance.data_model.data_model_toolbar.export')}}
            </span>
        </v-tooltip>
        <v-divider vertical class="divider"></v-divider>

        <!-- Choix du type d'entrée masqué pour le moment -->
        <!-- <span>
            {{$t('instance.data_model.data_model_toolbar.input_type')}}
        </span>
        <v-btn-toggle class="editor-type-button-container" :value="toggleEditType" mandatory dark>
            <v-btn
                icon
                dark
                @click="switchViewType(0)"
                :class="$t('instance.data_model.data_model_toolbar.btn_class')"
            >
                {{$t('instance.data_model.data_model_toolbar.switch.editor')}}
            </v-btn>
            <v-btn
                icon
                dark
                :disabled="schema.schemaHasError"
                @click="switchViewType(1)"
                :class="$t('instance.data_model.data_model_toolbar.btn_class')"
            >
                {{$t('instance.data_model.data_model_toolbar.switch.form')}}
            </v-btn>
        </v-btn-toggle> -->
    </v-app-bar>
</template>
<script>
import { isEqual, cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import rulesMixins from '@/components/Mixins/rulesMixins.vue';
export default {
    mixins: [rulesMixins],
    props: {
        modelsChanged: {
            type: Array,
            required: true
        },
        availableModels: {
            type: Array,
            required: true,
        },
        toggleEditType: {
            type: Number,
            required: true,
        },
        schema: {
            type: Object,
            required: true,
        },
        readOnly: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            chooseNewName: false,
            selectedModelUid: '',
            newModelName: '',
            formIsValid: true,
            caseSuggestion: null,
            duplicatingModel: false,
            modelToDuplicate:null,
            modelNameRules: [
                v => !!v || this.$t('instance.data_model.data_model_toolbar.modelNameRules_required'),
                v => !this.availableModels.find((avModel) => avModel.name === v) || this.$t('instance.data_model.data_model_toolbar.modelNameRules_exist'),
                v => v && !this.reservedKeyWords.includes(v) || `'${v}' ${this.$t('instance.data_model.data_model_toolbar.modelNameRules_reserved')}`,
            ],
            invalidNameCase: null,
        };
    },
    computed: {
        ...mapGetters([
            'reservedKeyWords'
        ]),

        // désactivé tant que le mode texte editeur est désactivé
        // modelNeedsToBeVerified() {
        //     if (this.schema.selectedModel === undefined) {
        //         return false;
        //     }
        //     if (!this.modelsChanged.includes(this.schema.selectedModel.name)) {
        //         return false;
        //     }
        //     return true;
        // },
        textDialog (){
            return this.$t('instance.data_model.data_model_toolbar.textDialog');
        },
        titleDialog (){
            return this.$t('instance.data_model.data_model_toolbar.titleDialog');
        },
        confirmButtonDialog() {
            return this.$t('instance.data_model.data_model_toolbar.confirmButtonDialog');
        },
        contentModified (){
            try{
                // obliger de faire le JSON.parse(JSON.stringify( car sinon le isEqual deconne avec les classes affecter aux clés
                return !isEqual(
                    JSON.parse(JSON.stringify(this.schema.remoteContent)),
                    JSON.parse(JSON.stringify(this.schema.schema))
                );
            }catch(e){
                return false;
            }
        },
        showSuggestion(){
            if(this.invalidNameCase){
                return true;
            }
            return false;
        },
        modelResetAvailable (){
            return [this.contentModified, this.schema.schemaHasError].some((val) => val === true );
        },

        // désactivé tant que le mode texte editeur est désactivé
        // disableRedrawGraph() {
        //     return this.schema.schemaHasError
        //         || this.toggleEditType === 1
        //         || this.schema.selectedModel === undefined
        //         || this.readOnly;
        // },
        // disableCheckSyntax () {
        //     return this.toggleEditType === 1 || this.schema.selectedModel === undefined || this.readOnly;
        // }

        modelList (){
            return this.schema.modelList;
        },
    },

    watch: {
        'schema.selectedModelUid' (val){
            if(!val) return;
            this.selectedModelUid = val;
        },
        currentLocale(){
            this.invalidNameCase = this.$helpers.invalidNameCase(this.newModelName);
        },
        newModelName(){
            this.invalidNameCase = null;
        }
    },

    mounted() {
        this.$eventBus.$on('on-choose-duplicate-model-name', this.triggerNameModal);
    },

    beforeDestroy (){
        this.$eventBus.$off('on-model-modified');
        this.$eventBus.$off('on-model-select');
        this.$eventBus.$off('on-model-create');
        this.$eventBus.$off('on-choose-duplicate-model-name');
    },

    methods: {
        onSelectModel (val){
            this.schema.setSelectedModelUid(val);
            this.$emit('focus-node', val);
        },
        triggerNameModal(duplicate = null) {
            if(duplicate){
                this.duplicatingModel = true;
                this.modelToDuplicate = duplicate;
            }
            this.chooseNewName = !this.chooseNewName;
            if (this.chooseNewName) {
                this.$nextTick(() => {
                    this.$refs.nameField.focus();
                });
            }
        },
        savePreviousModel() {
            if (this.schema.selectedModel !== undefined) {
                this.$emit('save-previous-model');
            }
        },
        createNewModel() {
            if (this.$refs.form.validate()) {
                this.invalidNameCase = this.$helpers.invalidNameCase(this.newModelName);
                if(this.invalidNameCase){
                    return;
                }
                this.$eventBus.$emit('on-create-new-model', this.newModelName);
                this.$store.commit('SET_SAVE_STATE', 'unsaved');
                this.$eventBus.$emit('update-data-model', this.schema.schema);
                this.resetCreateNewModel();
            }
        },
        duplicateModel(){
            if (this.$refs.form.validate()) {
                this.invalidNameCase = this.$helpers.invalidNameCase(this.newModelName);
                if(this.invalidNameCase){
                    return;
                }
                this.modelToDuplicate.name = this.newModelName;
                this.$eventBus.$emit('on-duplicate-model', this.modelToDuplicate);
                this.$store.commit('SET_SAVE_STATE', 'unsaved');
                this.$eventBus.$emit('save-schema');
                this.$eventBus.$emit('update-data-model', this.schema.schema);
                this.resetCreateNewModel();
            }
        },
        resetCreateNewModel (){
            this.chooseNewName = false;
            this.newModelName = '';
            this.invalidNameCase = null;
            this.modelToDuplicate = null;
            this.duplicatingModel = false;
        },
        applySuggestion(){
            this.newModelName = this.invalidNameCase.suggestion;
            this.invalidNameCase = null;
        }
        // Désactivé tant que le type d'entrée est masqué
        // switchViewType (val){
        //     this.savePreviousModel();
        //     this.$emit('switch-view-type', val);
        // },

        // désactivé tant que le mode texte editeur est désactivé
        // triggerCorrection() {
        //     this.$emit('trigger-correction');
        // },
    },
};

</script>
<style lang="scss">
.btn-create-model{
    background-color: #409EEF !important;
    padding-left: 14px;
    border-radius: 3px;
    font-size: 14px;
    &:hover{
        background-color: #cde5fb;
    }
}
.title{
    color : white;
}
.apply-suggestion-link{
    text-decoration: underline;
    margin-top: 4.5em;
    cursor: pointer;
}
.editor-toolbar{

    .spell-check-btn{
        border: 1px solid transparent;
        box-shadow: 18px -18px 0 2px #fff, -18px -18px 0 2px #fff, -18px 18px 0 2px #fff, 18px 18px 0 2px #fff, 0 0 0 2px;
    }

    .model-select{
        padding: 0;
        .v-input__slot{
            margin-bottom: 2px;
        }
        .v-messages__message {
            color: #FF9C75;
        }
    }
    .choose-model-name{
        position: absolute;
        z-index:10;
        min-width: 300px;
        padding: 5px 10px 0 10px;
        right: 0;
        // top: 80px;

        button{
            width: 20px;
            height: 20px;
        }
    }
    .content-modified{
        animation: blink 2s linear infinite;
    }
    .spellcheck-badge {
        .v-badge__badge  {
            top: 0;
            right: 0;
            height: 15px;
            width: 15px;
            font-size: 10px;
        }
    }
    .editor-type-button-container {
        background-color: #302E30;
        border: 1px solid hsla(0, 0%, 100%, .20);
        border-radius: 50px;
        margin-left: 6px;
        padding: 3px;
        .v-btn {
            border: none;
            border-radius: 20px;
            text-transform: unset;
            margin: 0;
            padding: 0 0 2px 0;
            width: 55px;
            height: 27px;
            &__large_btn {
                width: 75px;
            }
            &::before {
                border-radius: 50px;
            }
            &:nth-child(1) {
                margin-right: 5px;
            }
        }
    }
    .divider {
        align-self: unset;
        height: 50%;
        min-height: unset;
        margin-right: 15px;
    }
}
@keyframes blink {
  // 0% {
  //   // transform: translateZ(0);
  //   // box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  //   text-shadow: 0 0 0 #FFFFFF;
  // }
  // 100% {
  //   // transform: translateZ(50px);
  //   // box-shadow: 0 0 20px 0px rgba(0, 0, 0, 0.35);
  //   text-shadow: 0 0px 21px #FFFFFF;
  // }

  0% { box-shadow: 0 0 -5px #fff; }
  40% { box-shadow: 0 0 10px #fff; }
  60% { box-shadow: 0 0 10px #fff; }
  100% { box-shadow: 0 0 -5px #fff; }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/data-model-toolbar.vue